module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    class: {
      'on-top': _vm.$vuetify.breakpoint.lgAndUp
    },
    attrs: {
      "app": "",
      "fixed": "",
      "height": "82"
    }
  }, [_c('external-player'), _vm._v(" "), _c('v-layout', {
    staticClass: "ma-0 justify-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('player-progress-bar')], 1), _vm._v(" "), _c('v-flex', {
    class: {
      'player-disabled': !_vm.player.playlist.length
    },
    staticStyle: {
      "max-height": "72px",
      "min-height": "72px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "ma-0 fill-height",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only fill-height",
    staticStyle: {
      "flex": "2 /*so controls are centered*/"
    }
  }, [_c('player-info')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('player-controls')], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    staticStyle: {
      "flex": "2 /*so controls are centered*/"
    }
  }, [_c('current-playlist')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16c9891b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePlayer/ThePlayer.vue
// module id = 347
// module chunks = 0